import { render, staticRenderFns } from "./ExpandTransition.vue?vue&type=template&id=3b1accbd&scoped=true"
import script from "./ExpandTransition.vue?vue&type=script&lang=js"
export * from "./ExpandTransition.vue?vue&type=script&lang=js"
import style0 from "./ExpandTransition.vue?vue&type=style&index=0&id=3b1accbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1accbd",
  null
  
)

export default component.exports